import styled from "@emotion/styled";
import { zodResolver } from '@hookform/resolvers/zod';
import { LoadingButton as _LoadingButton } from '@mui/lab';
import { Box } from "@mui/material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { TypeOf, object, string } from 'zod';
import FormInput from "./Auth/FormInput";
import MyToastShow from "./Layout/MyToast";


const LoadingButton = styled(_LoadingButton)`
  padding: 0.6rem 0;
  font-weight: 500;
  &:hover {
    transform: translateY(-2px);
  }
`;

const resetPassSchema = object({

    password: string()
        .min(1, 'Necesitas ingresar una contraseña')
        .min(5, 'Debe ser más larga que 5 caracteres')
        .max(32, 'Elegí una menor a 32 caracteres'),
    confirmPassword: string()
        .min(1, 'Necesitas confirmar la contraseña')
})

type resetPassInput = TypeOf<typeof resetPassSchema>;


const ResetPasswordForm = ({ onSubmit, isLoading = false }: { onSubmit: (newPass: string) => void, isLoading?: boolean }) => {

    const methods = useForm<resetPassInput>({
        resolver: zodResolver(resetPassSchema),
    });

    const {
        handleSubmit
    } = methods;

    const onSubmitHandler: SubmitHandler<resetPassInput> = (values) => {
        if(values.password !== values.confirmPassword)
           return MyToastShow({message:'Las contraseñas no coinciden', type:'error'})

        onSubmit(values.password)
        
    };

    return (
        <FormProvider {...methods}>
            <Box
                component='form'
                onSubmit={handleSubmit(onSubmitHandler)}
                noValidate
                autoComplete='off'
                maxWidth='27rem'
                width='100%'
                sx={{
                    p: { xs: '1rem', sm: '2rem' },
                    borderRadius: 2,

                }}
            >
                <FormInput name='password' label='Contraseña' type='password' />
                <FormInput name='confirmPassword' label='Confirmar Contraseña' type='password' />



                <LoadingButton
                    variant='contained'
                    sx={{ mt: 1 }}
                    fullWidth
                    disableElevation
                    type='submit'
                    loading={isLoading}
                >
                    Resetear
                </LoadingButton>
            </Box>
        </FormProvider>
    );
}

export default ResetPasswordForm;